import { createSelector } from "reselect";
import { getFlyerState } from "../../../store/flyer.store";
import { IFlyerState } from "../../../types/flyer-state/flyer-state.interface";
import { FlyerTemplateCreatorState } from "../types/flyer-template-creator-state/flyer-template-creator-state.interface";
import Store from "../../../../../redux/store";
import * as actions from "./flyer-template-creator.actions";
import { GridLine } from "../../../features/flyer-template/types/grid/grid-line/grid-line.interface";
import { XyCoordinates } from "../../../features/flyer-template/types/xy-coordinates.interface";
import { GridCellSelectionRange } from "../types/grid-cell-selection-range/grid-cell-selection-range.interface";
import { Range } from "../../../../../types/range/range";
import { Canvas } from "../../../features/flyer-template/types/canvas/canvas.interface";
import { FlyerTemplatePosition } from "../../../features/flyer-template/types/flyer-template-position/flyer-template-position.interface";
import { FlyerTemplatePositionEditForm } from "../../../features/flyer-template/types/flyer-template-position-edit-form/flyer-template-position-edit-form.interface";

export const getFlyerTemplateCreatorState = createSelector(
  getFlyerState,
  (state: IFlyerState) => state.templateCreatorState
);

export const getErrors = createSelector(
  getFlyerTemplateCreatorState,
  (state?: FlyerTemplateCreatorState) => state?.errors || null
);

export const getGrid = createSelector(
  getFlyerTemplateCreatorState,
  (state?: FlyerTemplateCreatorState) => state?.grid || null
);

export const getTemplate = createSelector(
  getFlyerTemplateCreatorState,
  (state?: FlyerTemplateCreatorState) => state?.template || null
);

export const getCanvas = createSelector(
  getFlyerTemplateCreatorState,
  (state?: FlyerTemplateCreatorState) => state?.canvas || null
);

export const getEditingBlock = createSelector(
  getFlyerTemplateCreatorState,
  (state?: FlyerTemplateCreatorState) => state?.editingPosition || null
);

export const isLoading = createSelector(
  getFlyerTemplateCreatorState,
  (state?: FlyerTemplateCreatorState) => state?.isLoading || false
);

export function save() {
  Store.dispatch(actions.save());
}

export function reset() {
  Store.dispatch(actions.reset());
}

export function saveBlockDetails(form: FlyerTemplatePositionEditForm) {
  Store.dispatch(actions.savePositionDetails(form));
}

export function editPosition(position: FlyerTemplatePosition) {
  Store.dispatch(actions.setEditingPosition(position));
}

export function cancelEditingBlock() {
  Store.dispatch(actions.setEditingPosition(null));
}

export function setAspectRatio(ratio: number, screenWidth: number, screenHeight: number) {
  Store.dispatch(actions.setAspectRatio(ratio, screenWidth, screenHeight));
}

export function setTemplateName(name: string) {
  Store.dispatch(actions.setTemplateName(name));
}

export function createGrid() {
  Store.dispatch(actions.createGrid());
}

export function addRow() {
  Store.dispatch(actions.addRow());
}

export function addColumn() {
  Store.dispatch(actions.addColumn());
}

export function removeRow() {
  Store.dispatch(actions.removeRow());
}

export function removeColumn() {
  Store.dispatch(actions.removeColumn());
}

export function setRows(rows: number) {
  Store.dispatch(actions.setRows(rows));
}

export function setColumns(columns: number) {
  Store.dispatch(actions.setColumns(columns));
}

export function moveGridLine(line: GridLine, position: XyCoordinates) {
  Store.dispatch(actions.moveGridLine(line, position));
}

export function createBlock(selection: GridCellSelectionRange) {
  Store.dispatch(actions.createPosition(selection));
}

export function removePosition(positionId: number) {
  Store.dispatch(actions.removePosition(positionId));
}

export function movePosition(positionIndex: number, rows: Range, columns: Range) {
  Store.dispatch(actions.movePosition(positionIndex, rows, columns));
}

export function setCanvas(canvas: Canvas) {
  Store.dispatch(actions.setCanvas(canvas));
}

export function updateCanvas(canvas: Canvas) {
  Store.dispatch(actions.updateCanvas(canvas));
}
